import React from 'react';
import c from 'classnames';

export default function IconIntegrations(props: { className?: string }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={c('stroke-current', props.className)}>
            <path
                fill="none"
                d="m15.514 11.55-.643.643a1 1 0 0 0 0 1.415l.386.385a1 1 0 0 0 1.414 0l.643-.644 1.8 1.8a7.003 7.003 0 0 0 1.164-8.362l2.178-2.179a1 1 0 0 0 0-1.414L21.17 1.907a1 1 0 0 0-1.414 0l-2.178 2.179A7.003 7.003 0 0 0 9.214 5.25l1.8 1.8-.644.643a1 1 0 0 0 0 1.414l.386.385a1 1 0 0 0 1.414 0l.643-.643 2.702 2.7zM4.9 16.764l-2.18 2.178a1 1 0 0 0 0 1.414l1.286 1.286a1 1 0 0 0 1.414 0l2.178-2.178a7.003 7.003 0 0 0 8.364-1.164l-9.9-9.9A7.003 7.003 0 0 0 4.9 16.765z"
            />
        </svg>
    );
}
